<div class="w-full h-screen">
  <div class="flex flex-col justify-center items-center h-full">
    <!-- /Logo Box -->
    <div class="flex flex-col h-1/5 w-4/5 place-content-center">
      <a class="h-full w-full flex flex-col justify-center items-center" rel="noopener">
        <img class="w-1/2" [src]="logoUrl" alt="MAKEOS" />
      </a>
    </div>

    <div class="flex flex-col h-3/5 w-4/5 max-w-screen-sm place-content-center">
      <div class="flex flex-col justify-center h-full mb-2">
        <h2 class="text-center text-xl font-bold">Thanks for signing up for Serviceplan MAKEOS!</h2>

        <p class="text-center mt-8 text-sm">We sent a confirmation link to:</p>

        <p class="text-center mt-2 text-sm font-bold">{{ userEmailAddress }}</p>

        <!-- Back to login page -->
        <div class="flex flex-col justify-center mt-8">
          <a class="text-center font-bold underline text-lg" [routerLink]="['/login']">Back to log in</a>
        </div>
      </div>
    </div>

    <div class="flex flex-col h-1/5 w-4/5 max-w-screen-sm place-content-center">
      <div class="flex flex-col justify-end h-full mb-2">
        <!-- /Footer -->
        <sp-footer></sp-footer>
      </div>
    </div>
  </div>
</div>
